export default {
  namespaced: true,
  state: {
    backendUrl: 'https://appstore-api.rebble.io/api/v1',
    devPortalBackendUrl: 'https://appstore-api.rebble.io/api/v0',
    tosLink: 'https://rebble.io/tos/',
    contactLink: '',
    accessToken: null
  }
}



// WEBPACK FOOTER //
// ./src/store/config.js